var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4KredytyInwestycyjne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffcf5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #bec6c6;\n      }\n\n      .cls-3 {\n        fill: #1d1d1b;\n      }\n\n      .cls-4 {\n        fill: #ffa900;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 1,
    width: 40,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 5,
    width: 36,
    height: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25,
    cy: 43,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m45,6H5c-.55,0-1-.45-1-1V1c0-.55.45-1,1-1h40c.55,0,1,.45,1,1v4c0,.55-.45,1-1,1ZM6,4h38v-2H6v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m43,38H7c-.55,0-1-.45-1-1V5c0-.55.45-1,1-1h36c.55,0,1,.45,1,1v32c0,.55-.45,1-1,1Zm-35-2h34V6H8v30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2,26h10s5,3,5,3v-3s1,0,1,0c1.1,0,2-.9,2-2v-14c0-1.1-.9-2-2-2H2C.9,8,0,8.9,0,10v14c0,1.1.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11,22h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1-.45,1-1s-.45-1-1-1h-2c-1.65,0-3-1.35-3-3s1.35-3,3-3h4c.55,0,1,.45,1,1s-.45,1-1,1h-4c-.55,0-1,.45-1,1s.45,1,1,1h2c1.65,0,3,1.35,3,3s-1.35,3-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10,14c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10,24c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25,29h-3c-.55,0-1-.45-1-1s.45-1,1-1h2.43l2.71-4.51c.18-.3.51-.49.86-.49h3.54l5.7-6.65c.36-.42.99-.47,1.41-.11.42.36.47.99.11,1.41l-6,7c-.19.22-.47.35-.76.35h-3.43l-2.71,4.51c-.18.3-.51.49-.86.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38,20c-.55,0-1-.45-1-1v-2h-2c-.55,0-1-.45-1-1s.45-1,1-1h3c.55,0,1,.45,1,1v3c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 31,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28,
    y: 28,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35,
    y: 24,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m25,42c-.55,0-1-.45-1-1v-4c0-.55.45-1,1-1s1,.45,1,1v4c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m25,46c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3Zm0-4c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1-.45-1-1-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4KredytyInwestycyjne);
export default __webpack_public_path__ + "static/media/4-Kredyty-inwestycyjne.4b850cf0b8a54dd6186e00d4d808c41a.svg";
export { ForwardRef as ReactComponent };